import { Box, FormControl, Select, MenuItem, InputLabel } from '@mui/material';

import { useStyles } from './styles';

interface Items {
  id: number | string;
  name: string;
}

interface DropDownSelectorProps {
  label: string;
  currentId: number | string;
  items: Items[];
  handleCurrentId: (event: any) => void;
  disabled?: boolean;
}

export const DropDownSelector = ({
  label,
  currentId,
  items,
  handleCurrentId,
  disabled,
}: DropDownSelectorProps) => {
  const classes = useStyles();

  // Ensure we have at least one item and the currentId is a valid option
  const validItems = items.length > 0 ? items.map(item => item.id.toString()) : ['0'];
  const currentValue = validItems.includes(currentId.toString()) ? currentId.toString() : '';

  return (
    <Box className={classes.container}>
      <FormControl size='small' className={classes.formControl}>
        <InputLabel id="drop-down-selector-label">{label}</InputLabel>
        <Select
          label={label}
          value={currentValue}
          onChange={(event) => handleCurrentId(event.target.value.toString())}
          className={classes.dropdownSelect}
          disabled={disabled}
          MenuProps={{
            MenuListProps: { sx: { minWidth: '100%' } }
          }}
        >
          {items.length > 0 ? (
            items.map((item: Items) => (
              <MenuItem
                key={item.id}
                value={item.id.toString()}
                className={classes.dropdownItems}
              >
                {item.name}
              </MenuItem>
            ))
          ) : (
            <MenuItem value="0" className={classes.dropdownItems}>
              No items found or previous field needed
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </Box>
  );
};

export default DropDownSelector; 